import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

interface UploadButtonProps {
  onClick: () => void;
}

export const UploadButton = ({ onClick }: UploadButtonProps) => (
  <Button variant="ghost" size="icon" onClick={onClick}>
    <Upload className="h-4 w-4" />
  </Button>
);